import NotificationTypes from './notifications.types';

const notificationState = {
    notificationList:{}

}

export const setNotifications = (state = notificationState, action = {}) => {
    switch (action.type) {
        case NotificationTypes.FETCH_NOTIFICATIONS.SUCCESS:
            return Object.assign({}, state, { notificationList : action.payload })
        
        default:
            return state;
    }
}